/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloClient } from '@apollo/client'
import { getStoreV3 as query } from '@mercadoni/sinister/dist/cjs/shared/services'
import { Store } from '~types/index'
import saveStoreData from './saveStoreData'

interface GetStoreServiceParams {
  clientApollo: ApolloClient<any>
  setStore: (store: Store) => void
  clientId: string | null
  storeId: string
  setLoading: (status: boolean) => void
}

export const getStoreService = async ({
  clientApollo,
  setStore,
  clientId,
  storeId,
  setLoading,
}: GetStoreServiceParams) => {
  const response = await clientApollo.query({
    query,
    variables: { clientId, storeId },
  })

  const {
    data: { getStore },
  } = response

  if (getStore?.id) {
    const store = {
      ...getStore,
      reference: getStore?.code,
    }
    saveStoreData(store)
    setStore(store)
  }

  setLoading(false)
}
